import DataQuery from "data/DataQuery";
import { useQuery } from "data/hooks/useQuery";
import { DataGridId } from "features/shared/components/dataGrid/DataGridId";
import DataDescriptorDTO from "features/shared/dtos/DataDescriptorDTO";
import { getRouteParams } from "features/shared/helpers/routeParams";
import { useInjection } from "infrastructure/ioc/ioc.react";
import IAppState from "infrastructure/store/IAppState";
import CustomerState from "infrastructure/store/customer/CustomerState";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import IDataFilterService from "../IDataFilterService";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import IUrlParam from "features/shared/components/dataFilter/IUrlParam";
import { DataLoadStatus } from "data/enums/dataLoadStatus";

export const useDataFilterDefaults = (gridId: DataGridId, filterDefaultsUrl: string, execute: boolean = true): DataLoadStatus => {
  // DI
  const dataFilterService = useInjection<IDataFilterService>(IocTypes.DataFilterService);

  // store
  const customer = useSelector<IAppState, CustomerState>((store) => store.customer).customer;
  const filterUrlSearchParams = useSelector<IAppState, string | undefined>(
    (state) => state.dataGrid.gridSettings[gridId]?.filtrUrlSearchParams
  );

  // fetch data
  const dataQuery: DataQuery = {
    url: filterDefaultsUrl,
    routeParams: getRouteParams("customerId", customer.customerId!) 
  };
  const { data: filterDefaults, loadStatus: defaultsLoadStatus } = useQuery<DataDescriptorDTO[]>(
    dataQuery,
    [],
    [],
    { useTracker: true },
    { apply: true, condition: () => execute }
  );
  
  // helpers
  const setDefaultsToFilter = () => { 
    if (filterDefaults.length > 0) {
      let filterParams: IUrlParam[] = [];

      for (const defaultDesc of filterDefaults) {
        filterParams.push({ key: defaultDesc.code!, value: defaultDesc.value! });
      }

      dataFilterService.storeSetParams(gridId, filterParams);
    }
  }

  // side-effects
  useEffect(() => {
    // filter is empty
    if (!filterUrlSearchParams) {
      // filter has defaults to set
      setDefaultsToFilter();
    }
  }, [filterDefaults]);

  // return
  return defaultsLoadStatus;
}